export enum LeadType {
    BOOK_DEMO = 'BOOK_DEMO',
    GET_QUOTE = 'GET_QUOTE'
}

export interface LeadRequest {
    lead_type: LeadType | string;
    full_name: string;
    work_email: string;
    phone_number: string;
    company_name: string;
    company_size: string;
    hiring_volume: string;
    preferred_demo_date?: string | null;
    preferred_demo_time?: string | null;
    additional_information?: string | null;
}

export interface LeadResponse {
    status: string;
    message: string;
    data?: any;
}
